import React from "react";
import { connect } from "react-redux";
import { Popconfirm, message } from "antd";
import _ from "lodash";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import fontawesome from '@fortawesome/fontawesome';
import { faEye, faTrash } from '@fortawesome/fontawesome-free-solid';

fontawesome.library.add(faEye, faTrash);

//action imports

//component imports

//file imports

class Announcement extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            announcement: this.props.announcement
        }
    }

    componentWillReceiveProps(nextProps, nextContext) {
        if (nextProps.announcement !== this.props.announcement) {
            this.setState({
                announcement: nextProps.announcement
            })
        }
    }

    onDeleteAnnouncement(fileID) {
        //this.props.deleteCompanyFile(fileID);
    }

    onCancel() {
        message.info("Deletion is canceled").then();
    }

    renderAnnouncement() {
        const { announcement } = this.state;

        if (!(_.isEmpty(announcement))) {
            return(
                <div className={"announcementBox"} key={announcement.announcementID}>
                    <div style={{ backgroundColor: "red"}}>
                        <h4>{announcement.announcementTitle}</h4>
                        <div><p style={{width: '98%', wordBreak: 'break-all'}}>{announcement.announcementDescription}</p></div>
                    </div>
                    <div style={{ backgroundColor: "green" }}>
                        {
                            announcement.announcementFile ?
                                <div className={"clickable"} onClick={() => window.open(`${announcement.announcementFile}`,'name','width=700,height=600')}><FontAwesomeIcon icon="eye" color="#3294ff" size="1x" /></div>
                                : <p>No file</p>
                        }
                    </div>
                    <Popconfirm
                        title="Are you sure to delete this document?"
                        onConfirm={() => this.onDeleteAnnouncement(announcement.announcementID)}
                        onCancel={() => this.onCancel()}
                        okText="Yes"
                        cancelText="No"
                    >
                        <div className={"clickable"} style={{textAlign: 'center', justifyContent: "center", alignItems: "center", backgroundColor: "#D7373B"}}><FontAwesomeIcon icon={"trash"} color={"#ffffff"} size={"1x"} className={"trashIcon2"}/></div>
                    </Popconfirm>
                </div>
            );
        } else {
            return <h2>Choose an announcement to view</h2>
        }
    }

    render() {
        return(
            <div className={"newCustomerContainer"}>
                { this.renderAnnouncement() }
            </div>
        );
    }
}

const mapStateToProps = state => {
    const { announcement } = state.announcements;
    return {
        announcement
    }
}

export default connect(mapStateToProps, { })(Announcement);